// Medical-grade animation constants
// All timings and easing designed for professional, trust-building motion

export const ANIMATION_CONSTANTS = {
  // Timing durations (in milliseconds)
  DURATIONS: {
    FAST: 200,      // Quick interactions
    NORMAL: 400,    // Standard transitions
    SLOW: 600,      // Section reveals
    SLOWER: 750,    // Page transitions
    SLOWEST: 900,   // Complex animations
  },

  // Easing curves for medical precision
  EASING: {
    // Primary easing for most animations - smooth, confident, no bounce
    PRIMARY: [0.25, 0.46, 0.45, 0.94],
    // Secondary easing for subtle variations
    SECONDARY: [0.4, 0.0, 0.2, 1],
    // For quick, responsive interactions
    RESPONSIVE: [0.4, 0.0, 0.6, 1],
  },

  // Stagger delays for child elements
  STAGGER: {
    FAST: 0.05,     // Quick succession
    NORMAL: 0.1,    // Standard stagger
    SLOW: 0.15,     // Slower succession
    SLOWER: 0.2,    // Very slow succession
  },

  // Section reveal delays
  SECTION_DELAYS: {
    HERO: 0,
    FEATURES: 0.1,
    DETAILED_FEATURES: 0.2,
    PODCAST: 0.15,
    WORKFLOW: 0.25,
    TESTIMONIALS: 0.3,
    CTA: 0.35,
  },

  // Scroll behavior
  SCROLL: {
    DURATION: 750,  // Smooth scroll duration
    OFFSET: 80,     // Header offset for anchor links
  },
};

// Animation variants for common patterns
export const ANIMATION_VARIANTS = {
  // Fade in from bottom
  fadeInUp: {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: ANIMATION_CONSTANTS.DURATIONS.NORMAL / 1000,
        ease: ANIMATION_CONSTANTS.EASING.PRIMARY,
      },
    },
  },

  // Fade in from top
  fadeInDown: {
    hidden: { opacity: 0, y: -40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: ANIMATION_CONSTANTS.DURATIONS.NORMAL / 1000,
        ease: ANIMATION_CONSTANTS.EASING.PRIMARY,
      },
    },
  },

  // Scale in
  scaleIn: {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: ANIMATION_CONSTANTS.DURATIONS.NORMAL / 1000,
        ease: ANIMATION_CONSTANTS.EASING.PRIMARY,
      },
    },
  },

  // Slide in from left
  slideInLeft: {
    hidden: { opacity: 0, x: -40 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: ANIMATION_CONSTANTS.DURATIONS.NORMAL / 1000,
        ease: ANIMATION_CONSTANTS.EASING.PRIMARY,
      },
    },
  },

  // Slide in from right
  slideInRight: {
    hidden: { opacity: 0, x: 40 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: ANIMATION_CONSTANTS.DURATIONS.NORMAL / 1000,
        ease: ANIMATION_CONSTANTS.EASING.PRIMARY,
      },
    },
  },
};

// Container variants for staggered animations
export const CONTAINER_VARIANTS = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: ANIMATION_CONSTANTS.STAGGER.NORMAL,
      delayChildren: 0.1,
    },
  },
}; 